import { render, staticRenderFns } from "./FaIcon.vue?vue&type=template&id=2535db42&"
import script from "./FaIcon.vue?vue&type=script&lang=js&"
export * from "./FaIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports